var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.905 3C2.855 3 2 3.854 2 4.905v9.524c0 1.05.854 1.904 1.905 1.904h12.38c1.051 0 1.905-.854 1.905-1.904V4.905c0-1.05-.854-1.905-1.904-1.905H3.905zm16.19 3.81v11.428H5.81v1.905h14.285A1.919 1.919 0 0 0 22 18.238V6.81h-1.905zm-7.481 1.893l4.213 5.726H3.363l3.338-4.255 2.49 2.999 3.423-4.47z",
    id: "media-library-a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#media-library-a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaLibrary);
export default __webpack_public_path__ + "static/media/media-library.5c9018230237a3018ec9180b4e3d0e31.svg";
export { ForwardRef as ReactComponent };